import { getInstance } from './index';


export const authGuard = (to, from, next) => {
  const authService = getInstance();

  function trial_has_expired_func() {
    return authService.user['https://app.oceanbolt.com/trial_has_expired'] || false;
  }

  function trial_user_func() {
    return authService.user['https://app.oceanbolt.com/trial_user'] || false;
  }

  function get_permissions_func() {
    let userauth = authService.user['https://app.oceanbolt.com/user_authorization'] || {};
    return userauth.permissions;
  }


  const fn = () => {
    // must be called when authService.loading === false
    // otherwise permissions will be unreachable and page won't be loaded
    // even if all is ok with a user, it happens when for example the "/drydock" page is reloaded with F5

    if (!authService.isAuthenticated) {
      authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });

      // loginWithRedirect doesn't interrupt this method, so we need to return from it explicitely
      return next(false);
    }

    let permissions = get_permissions_func();
    let trial_user = trial_user_func();
    let trial_has_expired = trial_has_expired_func();

    // console.log('permissions', permissions);
    // console.log('trial_user', trial_user);
    // console.log('trial_has_expired', trial_has_expired);

    // If a non trial user
    if (!trial_user && to.path === '/expired') {
      return next({ name: 'Home' });
    }

    if (trial_user && !trial_has_expired && to.path === '/expired') {
      return next({ name: 'Home' });
    }

    if (trial_has_expired && trial_user && to.path !== '/expired') {
      return next({ name: 'expired' });
    }

    // per page permissions
    if (to.path === '/drydock' && !permissions.includes('read:drydock')) {
      return next({ name: 'accessdenied' });
    }

        // per page permissions
        if (to.path === '/drydock' && !permissions.includes('read:drydock')) {
          return next({ name: 'accessdenied' });
        }

    // per page permissions
    if (to.path === '/drydock-summary' && !permissions.includes('read:drydock')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/congestion' && !permissions.includes('read:congestion')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/congestion-summary' && !permissions.includes('read:congestion')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/tonnage-basins' && !permissions.includes('read:tonnage')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/tonnage-zones' && !permissions.includes('read:tonnage')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/tonnage-speed' && !permissions.includes('read:tonnage')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/tonnage-zone-map' && !permissions.includes('read:tonnage')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/tradeflows' && !permissions.includes('read:tradeflows')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/vessel-details' && !permissions.includes('read:tradeflows')) {
      return next({ name: 'accessdenied' });
    }


    if (to.path === '/live-map' && !permissions.includes('read:tradeflows')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/port-tradeflows' && !permissions.includes('read:tradeflows')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/ports-comparison' && !permissions.includes('read:tradeflows')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/edit-fleets' && !permissions.includes('read:tradeflows')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/fleet-monitor' && !permissions.includes('read:tradeflows')) {
      return next({ name: 'accessdenied' });
    }

    if (to.path === '/fleet-live-map' && !(permissions.includes('admin') || permissions.includes("beta:user"))) {
      return next({ name: 'accessdenied' });
    }


    // allow to navigate to a required url (user is authenticated here)
    return next();
  };

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn();
    }
  });
};
